import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_POSTS_BY_TYPE = gql`
  query Get($type: String, $types: [String]) {
    getPostsByType(type: $type, types: $types) {
      isAuth
      posts {
        _id
        slugName
        postCategory
        postName
        postDescription {
          title {
            en
          }
          image {
            en
          }
        }
      }
    }
  }
`;

const getPostsByType = async (type, types) => {
  try {
    const result = await client
      .query({
        query: GET_POSTS_BY_TYPE,
        variables: { type, types },
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getPostsByType: postsByTypeData },
    } = result;

    if (postsByTypeData) {
      return postsByTypeData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getPostsByType = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getPostsByType Error: ${error}`);
    return null;
  }
};

export default getPostsByType;
